export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-social-medium-1fd143733fb03c47f93117825b8a2fb5.svg";